import { Base, myBase } from './config';

class URLMaker {
  constructor(baseUrl: string, url: string) {
    this._baseURL = baseUrl;
    this._url = url;
  }

  protected _url: string;
  protected _baseURL = myBase;

  get baseURL() {
    return this._baseURL;
  }
  set baseURL(value: string) {
    this._baseURL = value;
  }

  get url() {
    return new URL(this._url, this._baseURL);
  }

  toString() {
    return this.url.toString();
  }
}

const urls = {
  /// MY MAP
  mySearch: new URLMaker(myBase, 'search'),
  myViews: new URLMaker(myBase, 'mym/views'),
  myStyleTile: new URLMaker(myBase, ''),
  myDatasources: new URLMaker(myBase, 'mym/datasources'),
  myServices: (service: string) => new URLMaker(myBase, 'mym/' + service),
  myTables: new URLMaker(myBase, 'editor/tables'),
  myImport: new URLMaker(myBase, 'transfer/import'),
  myExport: new URLMaker(myBase, 'transfer/export'),
  myShare: new URLMaker(myBase, 'mym/share'),
  myLogs: new URLMaker(myBase, 'log'),
  myMapping: new URLMaker(myBase, 'log/mappings'),
  captcha: new URLMaker(Base, 'captcha/new/easy/5/600'),
  //* Enrichment is done using Django framework, therefore needs the trailing slash (/) */
  myEnrich: new URLMaker(myBase, 'dataflow/enrichments/tasks/'),
  myEnrichType: new URLMaker(myBase, 'dataflow/enrichments/types/'),
  myEventManagerTypes: new URLMaker(myBase, 'event-manager/job-types'),
  myEventManagerTableJobs: new URLMaker(myBase, 'event-manager/table-jobs'),

  /// Map.ir
  fastReverse: new URLMaker(Base, 'fast-reverse'),
  autoComplete: new URLMaker(Base, 'search/v2/autocomplete'),
  route: new URLMaker(Base, 'routes/route/v1/driving'),
  login: new URLMaker(Base, 'register/tokens/user'),
  validation: new URLMaker(Base, 'register/tokens/validate'),
  refreshTokenUser: new URLMaker(Base, 'register/tokens/refresh'),
  profile: new URLMaker(Base, 'register/users/my-self'),
  users: new URLMaker(Base, 'register/users'),
  apps: new URLMaker(Base, 'register/apps'),
  roles: new URLMaker(Base, 'register/roles'),
  OTPSend: new URLMaker(Base, 'register/otp/send'),
  OTPCheck: new URLMaker(Base, 'register/otp/check'),
  media: new URLMaker(Base, 'media/'),
  notifications: new URLMaker(Base, 'notification'),
};

export default urls;
